export default __webpack_public_path__ + "static/media/unnamed.b97828ce.webp";